export interface HeroImage {
  id: string
  title: string
  author: string
  /** The Magnific page this image is catalogued on. */
  sourceUrl: string
  /** Local path under public/hero/, served by this app. */
  imageUrl: string
  license: string
  attributionRequired: boolean
  attributionText: string
}

export const MAGNIFIC_URL = 'https://www.magnific.com/'
export const MAGNIFIC_LICENSE_URL = 'https://www.magnific.com/ai/docs/licenses-attribution'

const LICENSE = 'Magnific Free License'
const ATTRIBUTION_TEXT = 'Designed by Magnific'
const AUTHOR = 'liuzishan'

export const HERO_IMAGES: HeroImage[] = [
  {
    id: 'challenger-spooky-castle',
    title: 'The Challenger Stands in Front of the Spooky Castle',
    author: AUTHOR,
    sourceUrl: 'https://www.magnific.com/free-photo/challenger-stands-front-spooky-castle-illustration_14402210.htm',
    imageUrl: '/hero/challenger-spooky-castle.jpg',
    license: LICENSE,
    attributionRequired: true,
    attributionText: ATTRIBUTION_TEXT,
  },
  {
    id: 'snow-mountains-castle',
    title: 'Snow-Capped Mountains and Castle (3D Rendering)',
    author: AUTHOR,
    sourceUrl: 'https://www.magnific.com/free-photo/snow-capped-mountains-castle-3d-rendering_14541109.htm',
    imageUrl: '/hero/snow-mountains-castle.jpg',
    license: LICENSE,
    attributionRequired: true,
    attributionText: ATTRIBUTION_TEXT,
  },
  {
    id: 'people-rock-sea-dusk',
    title: 'People in White Clothes Standing on a Rock by the Sea at Dusk',
    author: AUTHOR,
    sourceUrl:
      'https://www.magnific.com/free-photo/people-white-clothes-stand-rock-by-sea-dusk-looking-into-distance-illustration_14402220.htm',
    imageUrl: '/hero/people-rock-sea-dusk.jpg',
    license: LICENSE,
    attributionRequired: true,
    attributionText: ATTRIBUTION_TEXT,
  },
  {
    id: 'knights-medieval-castle',
    title: 'Knights of the Medieval Castle',
    author: AUTHOR,
    sourceUrl: 'https://www.magnific.com/free-photo/knights-medieval-castle_14541115.htm',
    imageUrl: '/hero/knights-medieval-castle.jpg',
    license: LICENSE,
    attributionRequired: true,
    attributionText: ATTRIBUTION_TEXT,
  },
  {
    id: 'wizard-dark-dungeon',
    title: 'Wizard in the Dark Dungeon',
    author: AUTHOR,
    sourceUrl: 'https://www.magnific.com/free-photo/wizard-dark-dungeon-illustration_14402228.htm',
    imageUrl: '/hero/wizard-dark-dungeon.jpg',
    license: LICENSE,
    attributionRequired: true,
    attributionText: ATTRIBUTION_TEXT,
  },
  {
    id: 'ancient-chinese-themes',
    title: 'A Fantastic Illustration of Ancient Chinese Themes',
    author: AUTHOR,
    sourceUrl: 'https://www.magnific.com/free-photo/fantastic-illustration-ancient-chinese-themes_14541139.htm',
    imageUrl: '/hero/ancient-chinese-themes.jpg',
    license: LICENSE,
    attributionRequired: true,
    attributionText: ATTRIBUTION_TEXT,
  },
]

export function pickRandomHeroImage(
  images: HeroImage[] = HERO_IMAGES,
  rand: () => number = Math.random,
): HeroImage {
  return images[Math.floor(rand() * images.length)]
}
